var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNettoBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 615.071,
    height: 273.749,
    viewBox: "0 0 615.071 273.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Netto_France_logo",
    transform: "translate(-0.404 0.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "translate(0.476 273.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M.2-214.3l.3,59.8h30L31-199l.5-44.5H120V-274H0Z",
    fill: "#e06008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M584.8-76.3l-.3,44.8-44.7.3L495-31V-1H615V-121H585Z",
    fill: "#e06008"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path911",
    d: "M495.034,258.043V243.071H527.04c17.6,0,37.816-.141,44.917-.314l12.911-.314V219.307c0-12.725.142-32.8.315-44.6l.315-21.467h29.314V273.015H495.034Z",
    fill: "#e06008",
    stroke: "#3673c6",
    strokeWidth: 0.071,
    fillRule: "evenodd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    d: "M495.747,258.2V244.088l22.1-.625c12.156-.344,32.262-.626,44.679-.627l22.577,0V153.475h29.469V272.3H495.747Z",
    fill: "#e06008",
    stroke: "#3673c6",
    strokeWidth: 0.143,
    fillRule: "evenodd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1082",
    d: "M495.747,258.2V244.088l22.1-.625c12.156-.344,32.262-.626,44.679-.627l22.577,0V153.475h29.469V272.3H495.747Z",
    fill: "#e06008",
    stroke: "#3673c6",
    strokeWidth: 0.143,
    fillRule: "evenodd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    d: "M1.074,117.114C.759,115.938.5,89.2.488,57.7L.475.426H119.3V29.9H30.9V48.753c0,10.372-.283,30.477-.628,44.679l-.628,25.821h-14c-13.71,0-14.007-.044-14.569-2.139Z",
    fill: "#e06008",
    stroke: "#3673c6",
    strokeWidth: 0.143,
    fillRule: "evenodd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1473",
    d: "M1.093,110.551C.753,105.766.475,79.03.475,51.138V.426H119.3V29.9H30.9V45.9c0,8.8-.283,28.909-.629,44.679l-.629,28.673H1.711Z",
    fill: "#e06008",
    stroke: "#e06008",
    strokeWidth: 0.143,
    fillRule: "evenodd",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNettoBlock);
export default __webpack_public_path__ + "static/media/netto_block.eab90a86d2f3066e7d524b1d8e1dd57c.svg";
export { ForwardRef as ReactComponent };